import Label from '@/components/UI/Label';
import styles from './InputField.module.css';
import React, { ChangeEventHandler, Ref } from 'react';

interface Props {
	name?: string;
	type: string;
	placeholder: string;
	title: string;
	required: boolean;
	labelClassName?: string;
	label?: string;
	value?: string | number;
	ref?: Ref<HTMLInputElement>;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	error?: boolean;
	disabled?: boolean;
	step?: string | number;
}

const InputField = React.forwardRef<HTMLInputElement, Omit<Props, 'ref'>>((props, ref) => {
	const classes = props.type === 'date' ? [styles.input_date] : [styles.input];
	if (props.error) {
		classes.push(styles.input_error);
	}

	return (
		<div className={styles.form_group}>
			{props.label && (
				<Label text={props.label} className={`${props.labelClassName ? props.labelClassName : ''} ${styles.label}`} />
			)}
			<input
				name={props.name}
				className={classes.join(' ')}
				title={props.title}
				type={props.type}
				placeholder={props.placeholder}
				ref={ref}
				onChange={props.onChange}
				value={props.value}
				disabled={props.disabled}
				min={props.type === 'number' ? 0 : undefined}
				step={props.step}
				onKeyDown={
					props.type === 'number'
						? (e) => {
								if (e.key === '-' || e.key === 'e' || e.key === 'E') {
									e.preventDefault();
								}
						  }
						: undefined
				}
			/>
		</div>
	);
});

export default InputField;
